/**
 * Utility functions for data manipulation
 */

/**
 * Removes undefined fields from an object
 * @param {Object} obj - The object to clean
 * @returns {Object} - Object without undefined fields
 */
export function cleanUndefinedFields(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => v !== undefined)
  );
}

/**
 * Prepares data for Firestore by removing undefined fields and id
 * @param {Object} data - The data object
 * @returns {Object} - Cleaned data without undefined fields and id
 */
export function prepareForFirestore(data) {
  const cleaned = cleanUndefinedFields(data);
  delete cleaned.id;
  return cleaned;
}

/**
 * Prepares data for Firestore update (keeps id separate)
 * @param {Object} data - The data object with id
 * @returns {Object} - Object with { id, updates } structure
 */
export function prepareForUpdate(data) {
  const cleaned = cleanUndefinedFields(data);
  const { id, ...updates } = cleaned;
  return { id, updates };
}





